export const MAX_PROMO_PHOTO_SIZE_MB = 10;
